import { useApi } from "../../../swr/useApi";
import { brandsService } from "../../api_client";
import type { BrandDto } from "../../../api";

export function useBrands() {
    return useApi<BrandDto[]>("brands", async () => {
        return await brandsService.getBrands();
    });
}

